import { createMuiTheme } from "@material-ui/core/styles";
import { customStyle } from "./config";

const customTheme = createMuiTheme(customStyle);

export { customTheme };
